// extracted by mini-css-extract-plugin
export default {"container":"Principal_container__GaCQI"};